import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShapeService } from '../shape.service';
import { HttpClient } from '@angular/common/http';
import { AppToastService } from 'src/app/shared/toast-service/toast-service';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-js-upload',
    templateUrl: './js-upload.component.html',
    styleUrls: ['./js-upload.component.scss'],
    standalone: false
})
export class JsUploadComponent {
  jsFile?: File;
  displayError: boolean = false;
  errorMessage: string = '';
  presignedJsUrl?: string;

  @Input() articleName!: string;
  @Output() finishedUpload = new EventEmitter<void>();

  /**
    * Use the first apiUrl for dev API access and the second for development with local backend.
    */
  apiUrl = environment.apiUrl;
  // apiUrl = environment.localUrl;

  constructor(
    private shapeService: ShapeService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    public toastService: AppToastService
  ) {}

  ngOnInit() {
    this.resetState();
    this.shapeService.getJsUploadPresignedUrl(this.articleName).subscribe({
      next: (url: string) => {
        this.presignedJsUrl = url;
      },
      error: (error: any) => {
        this.showError("Presigned URL could not be retrieved. Please reload and try again.");
        console.error(error);
      }
    });
  }
  
  /**
   * Handles the file selection event.
   * @param $event the file selection event.
   */
  public handleJsSelect($event: any) {
    console.log($event.target.files)
    this.displayError = false;
    const selectedJsFile = [...$event.target.files][0];
    this.jsFile = selectedJsFile ? selectedJsFile: this.jsFile;
  }

  /**
   * Retrieves the presigned URL for the passed in articleId and uploads the passed in file to it.
   * @param articleId the articleId to retrieve a presigned URL for
   */
  public importNewJs() {
    if (!this.jsFile) {
      this.showError("Please add a JS file first.");
    } else if (!this.presignedJsUrl) {
      this.showError("Could not retrieve the presigned URL, please reload and try again.");
    } else {
      this.spinner.show();
      this.backendJsUpload(this.presignedJsUrl, this.jsFile);
    }
  }

  /**
   * Uploads the passed in file to the passed in presigned URL via the backend.
   * @param presignedUrl the presigned URL to upload the file to
   * @param file the file to upload
   */
  private uploadJsFileToPresignedURL(presignedUrl: string, file: any) {
    this.http.put(presignedUrl, file).subscribe({
      next: (data: any) => {
        this.toastService.show(('Uploaded .js file successfully'), { classname: 'bg-success text-light', delay: 4000 });
        this.emitFinishedUpload();
      },
      error: (error: any) => {
        console.error("JS file could not be uploaded.");
        this.showError("JS file could not be uploaded.");
      }
    });
  }

  private backendJsUpload(presignedUrl: string, file: any) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("url", presignedUrl);
    let url: string = `${this.apiUrl}/api/DXFReader/UploadJsObjectToPresignedURL`;

    this.http.post(url, formData, { responseType: 'text' }).subscribe({
      next: (data: any) => {
        console.log("data: " + data);
        this.toastService.show(('Uploaded .js file successfully'), { classname: 'bg-success text-light', delay: 4000 });
        this.emitFinishedUpload();
      },
      error: (error: any) => {
        console.error("JS file could not be uploaded.");
        this.showError("JS file could not be uploaded.");
      }
    });
  }
  
  private showError(message: string) {
    this.displayError = true;
    this.errorMessage = message;
  }

  emitFinishedUpload() {
    console.log("emitting finished upload");
    this.finishedUpload.emit();
  }

  resetState() {
    console.log("resetting state of js upload component");
    this.jsFile = undefined;
    this.displayError = false;
    this.errorMessage = '';
    this.presignedJsUrl = undefined;
  }
}
